import React, { useState } from 'react'

const userDetails = { isAuthenticated: false }

export const UserContext = React.createContext(userDetails)
export const SetUserContext = React.createContext(() => {})

export const UserContextProvider = (props) => {
  let company = localStorage.getItem('company') || localStorage.getItem('company') !== undefined
  let token = localStorage.getItem('token')
  console.log({ company })
  const [user, setUser] = useState(
    token
      ? {
          token: JSON.parse(localStorage.getItem('token')),
          isAuthenticated: true,
          user: JSON.parse(localStorage.getItem('user')),
          company: company !== 'undefined' ? JSON.parse(localStorage.getItem('company')) : null,
        }
      : userDetails
  )
  const setContext = (token) => {
    //console.log(token)
    setUser({ isAuthenticated: true, token: token.token, user: token.user, company: token.company })
  }

  return (
    <UserContext.Provider value={user}>
      <SetUserContext.Provider value={setContext}>{props.children}</SetUserContext.Provider>
    </UserContext.Provider>
  )
}

export const UserContextConsumer = UserContext.Consumer
